import ConfigForm, { ConfigInput } from "components/Layout/ConfigForm";
import React from "react";

export interface SignatureDetailsProps {
  handleTaskItemNameChange: (event: any) => void;
  name: string;
}

function SignatureDetails({
  name,
  handleTaskItemNameChange,
}: SignatureDetailsProps) {
  const inputs: ConfigInput[] = [
    {
      required: true,
      title: "Prompt",
      type: "text",
      onChange: handleTaskItemNameChange,
      xs: 12,
      sm: 6,
      id: "taskItemName",
      value: name,
    },
  ];
  return (
    <ConfigForm
      title="Configure Signature Capture"
      inputs={inputs}
    ></ConfigForm>
  );
}

export default SignatureDetails;
